enum OrigemMovimentacao {
    Indefinido = 1,
    Venda = 2,
    Manipulacao = 3,
    Fracionamento = 4,
    MovimentacaoLote = 5,
    CancelamentoVenda = 6,
    CancelamentoManipulacao = 7,
    CancelamentoFracionamento = 8,
    NotaFiscalEntrada = 9,
    NotaFiscalSaida = 10,
    NotaFiscalEntradaViaXML = 11,
    NotaFiscalEmitida = 12,
    NotaDevolucao = 13,
    Inventario = 14,
    EntradaManual = 15,
    SaidaManual = 16,
    FracionamentoEntrada = 17,
    FracionamentoSaida = 18,
    FracionamentoAmostra = 19,
    FracionamentoPerda = 20,
    TransferenciaManual = 21,
    ResgateRecompensa = 22,
}

export default OrigemMovimentacao;
